// Centralized icon configuration for all tools
export const toolIcons = {
  // PDF Tools
  'pdf-to-jpg': 'mdi:file-image-outline',
  'pdf-to-png': 'mdi:file-image-outline',
  'merge-pdf': 'mdi:file-multiple-outline',
  'split-pdf': 'mdi:content-cut',
  'compress-pdf': 'mdi:file-compress-outline',
  'jpg-to-pdf': 'mdi:file-pdf-box',
  'word-to-pdf': 'mdi:file-word-box',
  'pdf-to-word': 'mdi:file-word-outline',

  // Image Tools
  'image-resizer': 'mdi:resize',
  'image-compressor': 'mdi:compress',
  'image-cropper': 'mdi:crop',
  'jpg-to-png': 'mdi:image-outline',
  'png-to-jpg': 'mdi:image-outline',
  'webp-to-jpg': 'mdi:image-outline',
  'image-converter': 'mdi:image-sync-outline',
  'remove-background': 'mdi:eraser',

  // Text Tools
  'word-counter': 'mdi:text-box-outline',
  'case-converter': 'mdi:format-letter-case',
  'lorem-ipsum': 'mdi:text',
  'json-formatter': 'mdi:code-braces',
  'diff-checker': 'mdi:compare',
  'markdown-editor': 'mdi:language-markdown-outline',

  // Dev & Other Tools
  'qr-generator': 'mdi:qrcode',
  'password-generator': 'mdi:key-variant',
  'base64-encode': 'mdi:code-tags',
  'base64-decode': 'mdi:code-tags',
  'color-picker': 'mdi:palette-outline',
  'url-encoder': 'mdi:link-variant',
  'url-decoder': 'mdi:link-variant-off',
  'uuid-generator': 'mdi:fingerprint',
} as const;

// UI Icons
export const uiIcons = {
  search: "mdi:magnify",
  menu: "mdi:menu",
  close: "mdi:close",
  sun: "mdi:white-balance-sunny",
  moon: "mdi:moon-waning-crescent",
  upload: "mdi:cloud-upload-outline",
  download: "mdi:download",
  refresh: "mdi:refresh",
  copy: "mdi:content-copy",
  check: "mdi:check",
  wrench: "mdi:wrench",
  image: "mdi:image-outline",
  fileText: "mdi:file-document-outline",
  loader: "mdi:loading",
  arrowLeft: "mdi:arrow-left",
  trash: "mdi:trash-can-outline",
} as const;
